import { FC, memo } from 'react'
import { H3 } from '@/components/atoms/typography'
import Link from '@/components/atoms/link'
import styled from 'styled-components'
import { Flex } from '@/components/atoms/Grid'
import { validFor } from '@/theme/validFor'
import { applyImagePolicy, getImageMode } from '@/utils/imageExtension'
import { useDomain } from '@/providers/storeProvider'

type ProductDetailManufacturerProps = {
  productBrandImage: string
  productBrand: string
  brandUrl: string
}

const ProductDetailManufacturer: FC<ProductDetailManufacturerProps> = ({
  productBrandImage,
  productBrand,
  brandUrl
}) => {
  const { subdomainName } = useDomain()
  return (
    <Link href={brandUrl}>
      <StyledFlex alignItems="center">
        {productBrandImage ? (
          <StyledImg
            src={applyImagePolicy(productBrandImage, {
              mode: getImageMode(subdomainName)
            })}
          />
        ) : (
          <StyledH3 m={0}>{productBrand}</StyledH3>
        )}
      </StyledFlex>
    </Link>
  )
}

export default memo(ProductDetailManufacturer)

const StyledH3 = styled(H3)`
  ${validFor.mobile`
	    font-size: 20px;
	`}
`

const StyledImg = styled.img`
  height: 100%;
  max-height: 50px;
  max-width: 160px;
`

const StyledFlex = styled(Flex)`
  ${validFor.mobile`
    width: 100%;
    justify-content: center;
  `}
`
